import React from "react";

import { IOSResponsiveIcons } from "./ios-responsive-icons/ios-responsive-icons";

export const IOSRootComponents: React.FC = () => {
  return <IOSResponsiveIcons />;
};
